"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function isPromise(value) {
    return typeof value === 'object' && typeof value.then === 'function';
}
exports.default = isPromise;



//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-beacon/dist/is-promise.js
// module id = 2103
// module chunks = 50